import { api } from "../../api";
import { v2ApiPath } from "../v2ApiPath";

/**
 * Dispatcher assistant endpoints on /api/v2.
 */
const assistantApi = api.injectEndpoints({
  endpoints: (builder) => ({
    sendAssistantMessage: builder.mutation({
      query: (body) => ({
        url: v2ApiPath("assistant/messages"),
        method: "POST",
        body,
      }),
    }),
    confirmAssistantAction: builder.mutation({
      query: ({ actionId, sessionId }) => ({
        url: v2ApiPath(`assistant/actions/${actionId}/confirm`),
        method: "POST",
        body: { sessionId },
      }),
      invalidatesTags: ["Jobs", "Legs", "Schedule", "Reports"],
    }),
    cancelAssistantAction: builder.mutation({
      query: ({ actionId, sessionId }) => ({
        url: v2ApiPath(`assistant/actions/${actionId}/cancel`),
        method: "POST",
        body: { sessionId },
      }),
    }),
  }),
});

export const {
  useSendAssistantMessageMutation,
  useConfirmAssistantActionMutation,
  useCancelAssistantActionMutation,
} = assistantApi;

export default assistantApi;
